import { authSelectors } from 'ducks/auth'
import { List } from 'elements/react-admin/List'
import { ComponentVersions_3_0, ComponentVersionsInherit, Typography } from 'opensolar-ui'
import {
  BooleanField,
  Create,
  Datagrid,
  Edit,
  EditButton,
  TextField,
  NumberField,
} from 'react-admin'
import { useSelector } from 'react-redux'

import { CheckpointForm } from './CheckpointForm'

export const CheckpointList = (props) => {
  const isSuperUser = useSelector(authSelectors.getIsSuperUser)

  if (!isSuperUser) {
    return (
      <ComponentVersionsInherit versions={ComponentVersions_3_0}>
        <Typography variant="body2">Superuser only.</Typography>
      </ComponentVersionsInherit>
    )
  }

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <List hasSearch={true} {...props}>
        <Datagrid>
          <TextField source="title" />
          <TextField source="type" />
          <TextField source="step_type" />
          <BooleanField source="is_required" />
          <NumberField source="priority" />
          <TextField source="country_iso2" label="Country" />
          <TextField source="redirect_path" />
          <EditButton color="inherit" />
        </Datagrid>
      </List>
    </ComponentVersionsInherit>
  )
}

export const CheckpointEdit = (props) => {
  const isSuperUser = useSelector(authSelectors.getIsSuperUser)

  if (!isSuperUser) {
    return (
      <ComponentVersionsInherit versions={ComponentVersions_3_0}>
        <Typography variant="body2">Superuser only.</Typography>
      </ComponentVersionsInherit>
    )
  }

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Edit {...props}>
        <CheckpointForm />
      </Edit>
    </ComponentVersionsInherit>
  )
}

export const CheckpointCreate = (props) => {
  const isSuperUser = useSelector(authSelectors.getIsSuperUser)

  if (!isSuperUser) {
    return (
      <ComponentVersionsInherit versions={ComponentVersions_3_0}>
        <Typography variant="body2">Superuser only.</Typography>
      </ComponentVersionsInherit>
    )
  }

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Create {...props}>
        <CheckpointForm />
      </Create>
    </ComponentVersionsInherit>
  )
}
